import React from 'react'
import SideBar from '../sideBar/SideBar'
import './layout.scss'
import TopNav from '../topNav/TopNav'
import { Outlet } from "react-router-dom";

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <SideBar />
      <div className="main_wrp_in">
        <TopNav />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout
